import { isBoolean, isString } from 'ohjs-is';
import scriptLoader from 'ohjs-script-loader';

const src = 'https://hosted.paysafe.com/js/v1/latest/paysafe.min.js';

function verify() {
  return (
    window.hasOwnProperty('paysafe') && window.paysafe.hasOwnProperty('fields')
  );
}

/**
 * Initializes a Paysafe instance on a set of fields
 *
 * @param {Object} options
 * @param {string} options.apiKey - Created from a single-use API token
 * @param {boolean} options.liveMode - Whether to be in LIVE or TEST mode.
 * @param {string} options.cardNumber - A selector of an empty DOM element.
 * @param {string} options.expiryDate - A selector of an empty DOM element.
 * @param {string} options.cvv - A selector of an empty DOM element.
 */
export default function ({
  apiKey,
  liveMode = false,
  cardNumberSelector,
  expiryDateSelector,
  cvvSelector,
}) {
  if (!apiKey || !isString(apiKey)) {
    throw '`options.apiKey` must be a non-empty string';
  }

  if (!isBoolean(liveMode)) {
    throw '`options.liveMode` must be a boolean';
  }

  if (!cardNumberSelector || !isString(cardNumberSelector)) {
    throw '`options.cardNumberSelector` must be a non-empty string';
  }

  if (!expiryDateSelector || !isString(expiryDateSelector)) {
    throw '`options.expiryDateSelector` must be a non-empty string';
  }

  if (!cvvSelector || !isString(cvvSelector)) {
    throw '`options.cvvSelector` must be a non-empty string';
  }

  const fieldOptions = {
    environment: liveMode ? 'LIVE' : 'TEST',
    fields: {
      cardNumber: {
        selector: cardNumberSelector,
        placeholder: 'Card number',
        separator: ' ',
      },
      expiryDate: {
        selector: expiryDateSelector,
        placeholder: 'Expiry date **/**',
      },
      cvv: {
        selector: cvvSelector,
        placeholder: 'CVV',
        optional: false,
      },
      style: {
        input: {
          'font-family': 'robotoregular,Helvetica,Arial,sans-serif',
          'font-weight': 'normal',
          'font-size': '14px',
          'line-height': '14px',
        },
        '.valid:focus': {
          color: 'green',
        },
      },
    },
  };

  return scriptLoader(src, verify).then(() => {
    return new Promise((resolve, reject) => {
      paysafe.fields.setup(apiKey, fieldOptions, (i, e) => {
        if (e) {
          reject(e); // Reject if there's an error
        } else {
          resolve(i); // Resolve with the instance
        }
      });
    });
  });
}
